import InspectionActionType, { ActiveInspection, Scope } from './inspection.types';
import type { InspectionAction } from './inspection.action';

export interface InspectionState {
  active: ActiveInspection | null;
  scope: Scope;
}

const INITIAL_STATE: InspectionState = {
  active: null,
  scope: { dccbId: null, branchId: null },
};

export default (state: InspectionState = INITIAL_STATE, action: InspectionAction): InspectionState => {
  switch (action.type) {
    case InspectionActionType.INSPECTION_SET_ACTIVE:
      // Opening an inspection also moves the bank/branch scope onto it, so the
      // observation and scoring screens follow the inspector instead of having
      // to be re-pointed by hand.
      return {
        active: action.payload,
        scope: { dccbId: action.payload.dccbId, branchId: action.payload.branchId },
      };
    case InspectionActionType.INSPECTION_CLEAR:
      return { ...state, active: null };
    case InspectionActionType.SCOPE_SET: {
      const next = { ...state.scope, ...action.payload };
      // A branch belongs to one bank; changing bank drops a branch that no
      // longer sits under it.
      if (action.payload.dccbId !== undefined && action.payload.dccbId !== state.scope.dccbId
          && action.payload.branchId === undefined) {
        next.branchId = null;
      }
      return { ...state, scope: next };
    }
    default:
      return state;
  }
};
